import Image from "next/image";
import React from "react";

type DownloadAppBannerProps = {
  data: Array<{
    banner_image: string;
    alt_text: string;
    banner_slot: {
      height: number;
      width: number;
    };
  }>;
};

export const DownloadAppBanner = ({ data }: DownloadAppBannerProps) => {
  if (data?.length == 0) return null;

  return (
    <Image
      id="download-app-banner"
      src={data[0]?.banner_image}
      alt={data[0]?.alt_text}
      width={data[0]?.banner_slot?.width || 300}
      height={data[0]?.banner_slot?.height || 200}
      className="cursor-pointer rounded-lg"
      priority={false}
    />
  );
};
